import {navigateTo} from '@typed-router';
import {storeToRefs} from 'pinia';
import {defineNuxtRouteMiddleware} from '#app';
import {useAdvancedSearchStore} from '~/features/advanced-search/stores/advancedSearch.store';
import {formatWorkflowKey} from '../utils/formatWorkflowKey';
import {resumableStepName} from '../utils/resolveAllowedStep';
import {useAdvancedSearchWorkflowSteps} from '../workflow';

export default defineNuxtRouteMiddleware((to) => {
    const advancedSearchStore = useAdvancedSearchStore();
    const {advancedSearch} = storeToRefs(advancedSearchStore);

    if (!advancedSearch.value) {
        return;
    }

    if (to.name === 's-advanced-briefId') {
        const briefId = to.params.briefId as string;

        const workflowKey = formatWorkflowKey(advancedSearch.value.workflow ?? 'LOW_INTENT');

        const allowedStep = resumableStepName(useAdvancedSearchWorkflowSteps(workflowKey), advancedSearch.value, workflowKey);

        return navigateTo(
            {
                name: 's-advanced-briefId-step',
                params: {briefId, step: allowedStep},
                query: {resumeDraft: 'true'},
            },
            {replace: true},
        );
    }
});
